import {
  CloseButton,
  CrudMode,
  ListContext,
  ListContextValue,
  Stack,
  Typography,
  UpdateButton,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { SubmitButton } from "components";
import { CustomDataModelField, Permission, PermissionAction } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const CustomDataModelFieldPageHeader = (props: {
  rootPermission: Permission;
  handle: string;
  crudMode: CrudMode;
  reroute: (id: number, crudMode: CrudMode) => void;
  fetch: (id: number) => void;
  customDataModelField: CustomDataModelField;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);
  const id = props.customDataModelField.id;

  const save = (customDataModelField: CustomDataModelField) => {
    props.setValidationErrors({});

    ApiService.customDataModelFields
      .saveUpdate(customDataModelField)
      .then(() => {
        props.reroute(id, "view");
        props.fetch(id);
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.response);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">
        {id === 0 ? "New" : ""} {props.handle}
      </Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />

        {props.crudMode === "view" && isAuthorized(props.rootPermission, PermissionAction.Update) && (
          <UpdateButton onClick={() => props.reroute(id, "edit")} />
        )}

        {props.crudMode === "edit" && (
          <SubmitButton onClick={() => save(props.customDataModelField)} disabled={!props.unsavedChanges} />
        )}
      </Stack>
    </Stack>
  );
};
